import { Button, dialog, InfiniteScroll, Progress } from "nq-component";
import BaseListPage from "../../../base/BaseListPage";
import {
  countObjectUseCase,
  deleteObjectUseCase,
  findObjectUseCase,
  upsertUseCase,
} from "../../../usecases/object";
import DTRAttachementPagePresenter from "./DTRAttachementPagePresenter";
import CardView from "../../../components/common/CardView";
import InputFactory from "../../../components/InputFactory";
import Table from "../../../components/Table";
import withRouter from "../../../withRouter";
import Search from "../../../components/Search";
import { DialogConfirmation } from "../../../components/common/Converter";

class DTRAttachementPage extends BaseListPage {
  constructor(props) {
    super(props);
    this.presenter = new DTRAttachementPagePresenter(
      this,
      findObjectUseCase(),
      countObjectUseCase(),
      deleteObjectUseCase(),
      upsertUseCase()
    );
    this.state = {
      openDeviceModal: false,
      openFingerModal: false,
      objects: [],
      count: 0,
      limit: 10,
      current: 1,
    };
  }

  async componentDidMount() {
    this.presenter.componentDidMount();
  }

  getCollectionName() {
    return "manual_dtr";
  }

  handleViewData(object) {
    this.navigateTo(`/view/${this.getCollectionName()}/${object.id}`);
  }

  // delete function
  async handleDeleteData(data) {
    DialogConfirmation(data.id, this.getCollectionName(), () =>
      this.refetchData()
    );
  }

  // edit function
  async handleEditData(id) {
    this.navigateTo(`/form/${this.getCollectionName()}/${id}`);
    // this.refetchData();
  }

  async handleAddManualDTR(id) {
    this.navigateTo(`/form/${this.getCollectionName()}`);
    // this.refetchData();
  }
  async refetchData() {
    const objects = await this.presenter.getObjects();
    this.filterSubmit({});
    return objects;
  }

  onClickPagination(page) {
    this.presenter.setCurrentPage(page);
  }

  setObjects(objects) {
    this.setState({ objects });
  }

  setCurrent(current) {
    this.setState({ current });
  }

  onChangeOption(field, value) {
    this.setState({ [field]: value });
    if (field === "employee") {
      this.onChangeFilter("Pointer", value, "employee");
    } else if (field === "username") {
      this.onChangeFilter("String", value, "username");
    }
  }

  render() {
    const schema = this.getSchema(this.getCollectionName());
    const { objects, loading, count, limit, current } = this.state;
    if (!schema) return <Progress />;

    console.log("OBJECTS: ", objects);

    return (
      <>
        <div className="overflow-auto" style={{ marginTop: "5rem" }}>
          <InfiniteScroll
            className="h-100"
            loadMore={this.loadMore.bind(this)}
            // hasMore={!progress && count > objects.length}
          >
            <div className="p-3 p-lg-4">
              <div
                className="d-flex mb-4"
                style={{ borderBottom: "1.5px solid #d3d3d3" }}
              >
                <p style={{ fontSize: ".9rem", color: "rgba(0, 0, 0, .45)" }}>
                  You are here: Home {">"} System Administration {">"}{" "}
                  <span
                    style={{ fontSize: "1rem", color: "rgba(0, 0, 0, .70)" }}
                  >
                    {schema.label}s
                  </span>
                </p>
              </div>
              <CardView style={{ borderRadius: 0 }}>
                <div className="d-flex mb-1">
                  {Object.keys(schema.filters || {}).map((field) => {
                    let { type, ...options } = schema.filters[field];
                    return (
                      <InputFactory
                        key={field}
                        className="ms-1"
                        type={type}
                        field={field}
                        where={{}}
                        onChange={this.onChangeFilter.bind(this, type)}
                        {...options}
                      />
                    );
                  })}
                </div>
                <Search
                  schemas={this.getSchemas()}
                  onSubmit={this.searchSubmit.bind(this)}
                  fields={schema.fields}
                />
              </CardView>

              <div
                style={{
                  marginTop: "20px",
                  width: "100%",
                }}
              >
                <CardView style={{ borderRadius: 0 }}>
                  <div className="d-flex align-items-center justify-content-center">
                    <h4 className="text-primary">{schema.label}s</h4>
                    <div style={{ marginLeft: "auto" }}>
                      <Button
                        onClick={this.handleAddManualDTR.bind(this)}
                        // onClick={this.onClickAdd.bind(this)}
                      >
                        <i className="bi bi-plus-lg" /> Add {schema.label}
                      </Button>
                    </div>
                  </div>
                </CardView>
              </div>

              <Table
                viewObject={this.handleViewData.bind(this)}
                objectId={this.handleDeleteData.bind(this)}
                editId={this.handleEditData.bind(this)}
                stepIncrement={(data) => this.presenter.handleResetPass(data)}
                progress={loading}
                refetch={this.refetchData.bind(this)}
                fields={schema.fields}
                objects={objects}
                collection={schema}
                count={count}
                limit={limit}
                current={current}
                loadPagination={this.onClickPagination.bind(this)}
                actionsList={[
                  {
                    label: <i className="bi bi-three-dots-vertical" />,
                    actionType: "common",
                  },
                ]}
                // selectable
                // collapsable
                excludeFields={Object.keys(schema.fields).reduce(
                  (acc, key) => {
                    const options = schema.fields[key];
                    if (options.read === false) {
                      acc.push(key);
                    }
                    switch (options._type || options.type) {
                      case "Relation":
                      case "Array":
                      case "Object":
                      case "File":
                        acc.push(key);
                        break;
                      default:
                    }
                    return acc;
                  },
                  ["id", "created", "updated"]
                )}
                onClickItem={this.onClickItem.bind(this)}
              />
            </div>
          </InfiniteScroll>
        </div>
      </>
    );
  }
}

export default withRouter(DTRAttachementPage);
